export const TIME_REFRESH = 'TIME_REFRESH';
export const timeRefresh = () => ({type: TIME_REFRESH});



/** WEBPACK FOOTER **
 ** ./src/members/state/lastTimeRefresh/actions.js
 **/